import axios from 'axios';
import { getUrl } from '../../MIS/Global';


const api = axios.create({
  baseURL: getUrl(),
  headers: {
    'Content-Type': 'application/json',
  },
});
 
 
 
export const getSettings = async (data) => {
  try {
    const queryParams = new URLSearchParams(data).toString();
    const response = await api.get(`settings/?${queryParams}`);    
    return response.data;
  } catch (error) {   
    // console.log(error)    
    throw new Error('Something went wrong. Please try again.');
  }
};



 